export const sidebars = [
  {
    icon: require("@/assets/icons/sidebars/home.svg"),
    title: "sidebarDashboard",
    url: "/",
    name: "dashboard-view",
    active: true,
    children: [],
    params: "",
  },
  {
    icon: require("@/assets/icons/sidebars/customer.svg"),
    title: "sidebarCustomer",
    url: "/customer",
    name: "customer-view",
    active: false,
    children: [],
    params: "",
  },
  {
    icon: require("@/assets/icons/sidebars/branch-store.svg"),
    title: "sidebarBranchStore",
    url: "/branch-store",
    name: "branch-store-view",
    active: false,
    children: [],
    params: "",
  },
  {
    icon: require("@/assets/icons/sidebars/product.svg"),
    title: "sidebarProduct",
    url: "/product",
    name: "product-view",
    active: false,
    children: [],
    params: "",
  },
  {
    icon: require("@/assets/icons/sidebars/stock.svg"),
    title: "sidebarStock",
    url: "/stock",
    name: "stock-view",
    active: false,
    children: [],
    params: "",
  },
  {
    icon: require("@/assets/icons/sidebars/sale-order.svg"),
    title: "sidebarSaleOrder",
    url: "/sale-order",
    name: "sale-order-view",
    active: false,
    children: [],
    params: "",
  },
  {
    icon: require("@/assets/icons/sidebars/promotion.svg"),
    title: "sidebarPromotion",
    url: "/promotion",
    name: "promotion-view",
    active: false,
    children: [],
    params: "",
  },
  {
    icon: require("@/assets/icons/sidebars/setting.svg"),
    title: "sidebarSetting",
    url: "/setting",
    name: "setting-view",
    active: false,
    children: [],
    params: "",
  },
];
